import { useSelector } from "react-redux";

import EbookPage from "./EbookPage";
import PhonicsStepPage from "./phonics/PhonicsStepPage";

// 리더스북(지인에듀, 2026-10-17). 섹션은 모두 전자책(ebook) 유형이다. 파닉스북(2026-10-19)은 단계마다 섹션이 따로다.
const PHONICS_STEP_PAGE_LIST = ["mouth", "story", "speak", "quiz"];

const ReadersBookPage = ({ setCurrentStep, isPreview, isReview }) => {
  const { section } = useSelector((state) => state.assignment);

  // 파닉스북의 입모양 · 이야기 듣기 · 문제 섹션(책 넘겨 보기는 phonics_step 이 book 이라 EbookPage 로 간다)
  if (section?.type === "ebook" && PHONICS_STEP_PAGE_LIST.includes(section.question?.phonics_step)) {
    return <PhonicsStepPage setCurrentStep={setCurrentStep} isPreview={isPreview} isReview={isReview} />;
  }
  if (section?.type === "ebook") {
    return <EbookPage setCurrentStep={setCurrentStep} isPreview={isPreview} isReview={isReview} />;
  }
  return null;
};

export default ReadersBookPage;
